import React from 'react'

function Svg8(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#8_svg__clip0)">
        <rect
          x={4.08}
          y={7.581}
          width={2.34}
          height={8.838}
          rx={1.17}
          stroke="currentColor"
          strokeWidth={0.909}
        />
        <rect
          x={6.419}
          y={6.42}
          width={2.34}
          height={11.159}
          rx={1.17}
          stroke="currentColor"
          strokeWidth={0.909}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.92 13.624h.453a1.624 1.624 0 100-3.248h-.452v.909h.452a.715.715 0 010 1.43h-.452v.91zm-4.679-.909v.91H8.76v-.91h6.482zm0-1.43v-.91H8.76v.91h6.482zm-8.822 1.43v.91-.91zm-2.34 0v.91h-.688a1.624 1.624 0 110-3.25h.688v.91h-.688a.715.715 0 000 1.43h.688zm2.34-1.43v-.91.91z"
          fill="currentColor"
        />
        <rect
          x={19.92}
          y={16.419}
          width={2.34}
          height={8.838}
          rx={1.17}
          transform="rotate(-180 19.92 16.419)"
          stroke="currentColor"
          strokeWidth={0.909}
        />
        <rect
          x={17.581}
          y={17.58}
          width={2.34}
          height={11.159}
          rx={1.17}
          transform="rotate(-180 17.58 17.58)"
          stroke="currentColor"
          strokeWidth={0.909}
        />
      </g>
      <defs>
        <clipPath id="8_svg__clip0">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Svg8
